export const DOCUMENT_VARIABLES = {
  // N-party Interior Design & Execution Agreement. Repeating/annexure sections are assembled by the
  // backend into single tokens ({parties_block}, {annexures_block}, {signatures_block}); the headline
  // tokens are simple values.
  INTERIOR_EXECUTION_AGREEMENT: [
    { label: 'Agreement No.', value: '{agreement_no}' },
    { label: 'Agreement Date', value: '{agreement_date}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Phase Name', value: '{phase_name}' },
    { label: 'Unit No.', value: '{unit_no}' },
    { label: 'Developer Name', value: '{developer_name}' },
    { label: 'BuildVizer Name', value: '{buildvizer_name}' },
    { label: 'Interior Designer Name', value: '{designer_name}' },
    { label: 'Buyer Name(s)', value: '{buyer_names}' },
    { label: 'Parties Block (all parties)', value: '{parties_block}' },
    { label: 'Annexures Block (A–P)', value: '{annexures_block}' },
    { label: 'Signatures Block (all signers)', value: '{signatures_block}' },
  ],
  TOKEN_PAYMENT: [
    { label: 'Received Date', value: '{received_date}' },
    { label: 'User Name', value: '{user_name}' },
    { label: 'Currency Name', value: '{currency_name}' },
    { label: 'Received Amount', value: '{received_amount}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Property No', value: '{property_no}' },
    { label: 'Base Price', value: '{base_price}' },
    { label: 'Payment Type', value: '{payment_type}' },
    { label: 'Remaining Balance', value: '{remaining_balance}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  BOOKING_LETTER: [
    { label: 'Name', value: '{name}' },
    { label: 'User Address', value: '{user_address}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Property Type', value: '{property_type}' },
    { label: 'Unit No.', value: '{property_no}' },
    { label: 'Building', value: '{building_no}' },
    { label: 'Floor', value: '{floor}' },
    { label: 'Area', value: '{carpet_area}' },
    { label: 'Agreement Value Amount', value: '{base_price}' },
    { label: 'Govt Charges', value: '{govt_charges}' },
    { label: 'Booking Amount', value: '{booking_amount}' },
    { label: 'Balance Amount', value: '{balance_payment}' },
    { label: 'Booking Date', value: '{booking_date}' },
    { label: 'Channel Partner Name', value: '{agent_name}' },
    { label: 'Channel Partner Cell No', value: '{agent_number}' },
    { label: 'Channel Partner RERA Number', value: '{rera_number}' },
    { label: 'Booking Letter Terms', value: '{booking_letter_terms}' },
    { label: 'Current Date', value: '{current_date}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  CANCELLATION_LETTER: [
    { label: 'Name', value: '{name}' },
    { label: 'User Address', value: '{user_address}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Property Type', value: '{property_type}' },
    { label: 'Unit No.', value: '{property_no}' },
    { label: 'Floor', value: '{floor}' },
    { label: 'Area', value: '{carpet_area}' },
    { label: 'Currency Name', value: '{currency_name}' },
    { label: 'Agreement Value Amount', value: '{base_price}' },
    { label: 'Govt Charges Paid', value: '{govt_charges}' },
    { label: 'Amount Paid by Customer', value: '{total_amount_paid}' },
    { label: 'Refundable Amount by Developer', value: '{refund_amount}' },
    { label: 'Booking Date', value: '{booking_date}' },
    { label: 'Cancellation Request Date', value: '{cancellation_initiated_date}' },
    { label: 'Cancellation Letter Terms', value: '{cancellation_letter_terms}' },
    { label: 'Current Date', value: '{current_date}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  PROPERTY_HANDOVER_LETTER: [
    { label: 'Name', value: '{name}' },
    { label: 'User Address', value: '{user_address}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Project Address', value: '{project_address}' },
    { label: 'Property Type', value: '{property_type}' },
    { label: 'Unit No.', value: '{property_no}' },
    { label: 'Floor No.', value: '{floor}' },
    { label: 'Area', value: '{carpet_area}' },
    { label: 'Handover Date', value: '{handover_date}' },
    { label: 'Property Sale Type', value: '{property_sale_type}' },
    { label: 'Handover Letter Terms', value: '{handover_letter_terms}' },
    { label: 'Current Date', value: '{current_date}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  CANCELLATION_REFUND: [
    { label: 'Current Date', value: '{current_date}' },
    { label: 'Property No', value: '{property_no}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Project Address', value: '{project_address}' },
    { label: 'Cancellation Initiated Date', value: '{cancellation_initiated_date}' },
    { label: 'Currency Name', value: '{currency_name}' },
    { label: 'Base Price', value: '{base_price}' },
    { label: 'Total Amount Paid', value: '{total_amount_paid}' },
    { label: 'Refund Amount', value: '{refund_amount}' },
    { label: 'Refund Amount Details', value: '{refund_amount_details}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  DOWN_PAYMENT: [
    { label: 'Received Date', value: '{received_date}' },
    { label: 'User Name', value: '{user_name}' },
    { label: 'Currency Name', value: '{currency_name}' },
    { label: 'Received Amount', value: '{received_amount}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Property No', value: '{property_no}' },
    { label: 'Base Price', value: '{base_price}' },
    { label: 'Payment Type', value: '{payment_type}' },
    { label: 'Remaining Balance', value: '{remaining_balance}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  SCHEDULED_PAYMENT: [
    { label: 'Received Date', value: '{received_date}' },
    { label: 'Receipt Number', value: '[Receipt Number]' },
    { label: 'User Name', value: '{user_name}' },
    { label: 'Currency Name', value: '{currency_name}' },
    { label: 'Received Amount', value: '{received_amount}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Property No', value: '{property_no}' },
    { label: 'Projected Date', value: '{projected_date}' },
    { label: 'Total Cost', value: '{total_cost}' },
    { label: 'Payment Type', value: '{payment_type}' },
    { label: 'Remaining Balance', value: '{remaining_balance}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  FULL_PAYMENT: [
    { label: 'Received Date', value: '{received_date}' },
    { label: 'User Name', value: '{user_name}' },
    { label: 'Currency Name', value: '{currency_name}' },
    { label: 'Received Amount', value: '{received_amount}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Property No', value: '{property_no}' },
    { label: 'Base Price', value: '{base_price}' },
    { label: 'Details', value: '{details}' },
    { label: 'Remaining Balance', value: '{remaining_balance}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  SLAB_WISE_PAYMENT: [
    { label: 'Received Date', value: '{received_date}' },
    { label: 'User Name', value: '{user_name}' },
    { label: 'Currency Name', value: '{currency_name}' },
    { label: 'Received Amount', value: '{received_amount}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Property No', value: '{property_no}' },
    { label: 'Base Price', value: '{base_price}' },
    { label: 'Payment Type', value: '{payment_type}' },
    { label: 'Building Status', value: '{building_status}' },
    { label: 'Remaining Balance', value: '{remaining_balance}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  SCHEDULED_DEMAND_LETTERS_USER: [
    { label: 'User Name', value: '{user_name}' },
    { label: 'User Address', value: '{user_address}' },
    { label: 'Property No', value: '{property_no}' },
    { label: 'Building No', value: '{building_no}' },
    { label: 'Floor', value: '{floor}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Project Address', value: '{project_address}' },
    { label: 'Company Name', value: '{company_name}' },
    { label: 'Base Price', value: '{base_price}' },
    { label: 'Project Status Description', value: '{project_status_description}' },
    { label: 'Amount', value: '{amount}' },
    { label: 'Total Amount Paid', value: '{total_amount_paid}' },
    { label: 'Projected Date', value: '{projected_date}' },
    { label: 'Balance Payment', value: '{balance_payment}' },
    { label: 'RERA Number', value: '{rera_no}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
    { label: 'Bank Details', value: '{bank_details}' },
  ],
  SCHEDULED_DEMAND_LETTERS_BANK: [
    { label: 'Bank Name', value: '{bank_name}' },
    { label: 'Bank Branch', value: '{bank_branch}' },
    { label: 'Property No', value: '{property_no}' },
    { label: 'Building No', value: '{building_no}' },
    { label: 'Project Name', value: '{project_name}' },
    { label: 'Title', value: '{title}' },
    { label: 'User Name', value: '{user_name}' },
    { label: 'Sale Date', value: '{sale_date}' },
    { label: 'Projected Date', value: '{projected_date}' },
    { label: 'Amount', value: '{amount}' },
    { label: 'Currency', value: '{currency}' },
    { label: 'RERA Number', value: '{rera_no}' },
    { label: 'Bank Details', value: '{bank_details}' },
    { label: 'Phase Rera Number', value: '{phase_rera_number}' },
  ],
  // Add more document types and their variables here as needed
};

// Dummy data for variable replacement in preview
export const DUMMY_DATA = {
  // Common variables
  '{name}': 'John Smith',
  '{user_name}': 'John Smith',
  '{user_address}': '123 Main Street, Apartment 4B, New York, NY 10001',
  '{current_date}': new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  }),
  '{received_date}': new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  }),
  '{currency_name}': 'INR (₹)',
  '{project_name}': 'Stark Tower Residences',
  '{project_address}': '200 Park Avenue, New York, NY 10166',
  '{property_type}': 'Apartment',
  '{property_no}': 'A-1501',
  '{building_no}': 'Tower A',
  '{floor}': '15th Floor',
  '{carpet_area}': '1,250 sq ft',
  '{base_price}': '₹2,50,00,000',
  '{govt_charges}': '₹12,50,000',
  '{booking_amount}': '₹25,00,000',
  '{balance_payment}': '₹2,25,00,000',
  '{booking_date}': '15th January, 2024',
  '{agent_name}': 'Tony Stark',
  '{agent_number}': '+91 98765 43210',
  '{rera_number}': 'RERA/2024/001234',
  '{booking_letter_terms}': 'Standard booking terms and conditions apply. Payment schedule as per agreement.',
  '{handover_date}': '30th June, 2024',
  '{property_sale_type}': 'Ready to Move',
  '{handover_letter_terms}': 'Property handover terms and conditions as per agreement.',
  '{cancellation_initiated_date}': '20th February, 2024',
  '{cancellation_letter_terms}': 'Cancellation processed as per policy. Refund will be processed within 30 days.',
  '{total_amount_paid}': '₹50,00,000',
  '{refund_amount}': '₹45,00,000',
  '{refund_amount_details}': 'Booking amount minus processing fees',
  '{received_amount}': '₹50,00,000',
  '{total_cost}': '₹2,50,00,000',
  '{payment_type}': 'Bank Transfer',
  '{remaining_balance}': '₹2,00,00,000',
  '{projected_date}': '15th March, 2024',
  '{building_status}': 'Under Construction - 60% Complete',
  '{details}': 'Final payment for property purchase',
  '[Receipt Number]': 'RCP-2024-001234',
  // SCHEDULED_DEMAND_LETTERS_BANK variables
  '{bank_name}': 'State Bank of India',
  '{bank_branch}': 'Connaught Place Branch, New Delhi',
  '{title}': 'Mr.',
  '{sale_date}': '15th January, 2024',
  '{amount}': '₹50,00,000',
  '{currency}': 'INR',
  '{rera_no}': 'RERA/2024/001234',
  '{bank_details}': 'Account Name: Stark Tower Developers Pvt Ltd\nAccount Number: 1234567890\nIFSC Code: SBIN0001234\nBranch: Connaught Place, New Delhi',
  // SCHEDULED_DEMAND_LETTERS_USER variables
  '{company_name}': 'Stark Tower Developers Pvt Ltd',
  '{project_status_description}': 'Foundation and Structure Complete - 60%',
  '{project_address}': '200 Park Avenue, New York, NY 10166',
};

// Function to replace variables with dummy data
export const replaceVariablesWithDummyData = (content) => {
  if (!content) return content;
  
  let replacedContent = content;
  
  // Replace all variables with dummy data
  Object.keys(DUMMY_DATA).forEach(variable => {
    const regex = new RegExp(variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
    replacedContent = replacedContent.replace(regex, DUMMY_DATA[variable]);
  });
  
  return replacedContent;
}; 